import { LeadCompletedForm } from "@/features/establishmentLeadsFunnel/components/leadFormStates/LeadCompletedForm"
import { LeadDeployingForm } from "@/features/establishmentLeadsFunnel/components/leadFormStates/LeadDeployingForm"
import { LeadDeployingManagementReviewForm } from "@/features/establishmentLeadsFunnel/components/leadFormStates/LeadDeployingManagementReviewForm"
import { LeadQualifyingClientChangesRequestedForm } from "@/features/establishmentLeadsFunnel/components/leadFormStates/LeadQualifyingClientChangesRequestedForm"
import { LeadQualifyingForm } from "@/features/establishmentLeadsFunnel/components/leadFormStates/LeadQualifyingForm"
import { LeadQualifyingQuoteClientReviewForm } from "@/features/establishmentLeadsFunnel/components/leadFormStates/LeadQualifyingQuoteClientReviewForm"
import { LeadQualifyingQuoteForm } from "@/features/establishmentLeadsFunnel/components/leadFormStates/LeadQualifyingQuoteForm"
import { LeadQualifyingReviewForm } from "@/features/establishmentLeadsFunnel/components/leadFormStates/LeadQualifyingReviewForm"
import { LeadRegisteredForm } from "@/features/establishmentLeadsFunnel/components/leadFormStates/LeadRegisteredForm"

export const leadFormStateOptions = [
  {
    value: 'registered',
    comp: LeadRegisteredForm,
  },
  {
    value: 'qualifying',
    comp: LeadQualifyingForm,
  },
  {
    value: 'qualifying_quote_client_review',
    comp: LeadQualifyingQuoteClientReviewForm,
  },
  {
    value: 'qualifying_client_changes_requested',
    comp: LeadQualifyingClientChangesRequestedForm,
  },
  {
    value: 'qualifying_review',
    comp: LeadQualifyingReviewForm,
  },
  {
    value: 'qualifying_quote',
    comp: LeadQualifyingQuoteForm,
  },
  {
    value: 'deploying',
    comp: LeadDeployingForm,
  },
  {
    value: 'deploying_management_review',
    comp: LeadDeployingManagementReviewForm,
  },
  {
    value: 'completed',
    comp: LeadCompletedForm,
  },
]
